export default {"src":"/_next/static/media/whiteCloseBtn.3dbc198a.svg","height":18,"width":18};